import { notifications } from "@marketplace/ui/notifications";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import type { ResendVerificationRequestDto } from "../../dtos/resend-verification-request-dto";
import type { ResendVerificationResponseDto } from "../../dtos/resend-verification-response-dto";
import { UserService } from "../../services/user-service";

export type UseResendVerificationMutationParams = {
  options?: UseMutationOptions<
    ResendVerificationResponseDto,
    unknown,
    ResendVerificationRequestDto
  >;
};

export const useResendVerificationMutation = ({
  options
}: UseResendVerificationMutationParams = {}) => {
  const { t } = useTranslation("users", {
    keyPrefix: "sellerListPage.notifications"
  });

  return useMutation({
    mutationFn: async (payload) => {
      return await UserService.resendVerification({
        payload
      });
    },
    onSuccess: async (...args) => {
      notifications.show({
        message: t("resendVerificationSuccess")
      });

      options?.onSuccess?.(...args);
    },
    onError: (...errorArgs) => {
      notifications.show({
        variant: "error",
        message: t("resendVerificationFailed")
      });

      options?.onError?.(...errorArgs);
    },
    ...options
  });
};
